<template>
  <div
    class="mx-auto"
    style="max-width: 650px;"
  >
    <h3 class="primary--text mb-5">
      Welcome, {{ user.first_name }}
    </h3>

    <v-card
      v-for="(option, key) in options"
      :key="`key_${key}`"
      class="pt-10 pb-12 mb-5"
    >
      <v-card-title class="pt-0">
        <span :class="option.title === 'Cobranding' ? 'pr-2' : null">
          {{ option.title }}
        </span>
        <div
          v-if="option.title === 'Cobranding' && option.disabled"
          class="caption pt-1"
        >
          (Available upon upgrade)
        </div>
        <v-img
          v-if="option.icon"
          class="mx-5"
          contain
          :src="option.icon"
          max-width="45"
          max-height="45"
        />
      </v-card-title>
      <v-card-text class="pb-0 d-flex align-center justify-space-between">
        <v-row align="center">
          <v-col
            cols="12"
            sm="10"
          >
            {{ option.description }}
          </v-col>
          <v-col
            cols="12"
            sm="2"
          >
            <v-btn
              v-if="option.direct"
              color="primary lighten-2"
              class="px-0"
              outlined
              rounded
              block
              :disabled="option.disabled"
              @click="sendToDirect(option.direct)"
            >
              <div class="flex align-center">
                Link
                <v-icon
                  class="ml-0"
                  small
                >
                  mdi-open-in-new
                </v-icon>
              </div>
            </v-btn>
            <v-btn
              v-else
              color="primary lighten-2"
              outlined
              rounded
              block
              :disabled="option.disabled"
              @click="$router.push(option.cta)"
            >
              View
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Home',

  data: () => ({ }),

  computed: {
    ...mapState({
      user: (state) => state.account.user,
    }),

    options() {
      const options = [
        {
          title: 'Personal Info',
          // eslint-disable-next-line global-require
          icon: require('@/assets/settings/personal_info.png'),
          description: 'Update your basic information, profile information, timezone, etc.',
          cta: { name: 'profileInfo' },
          disabled: false,
        },
        {
          title: 'Security',
          // eslint-disable-next-line global-require
          icon: require('@/assets/settings/security.png'),
          description: 'Protect your account by resolving and preventing security issues',
          cta: { name: 'security' },
          disabled: false,
        },
        // {
        //   title: 'Cobranding',
        //   // eslint-disable-next-line global-require
        //   // icon: require('@/assets/settings/security.png'),
        //   description: 'Make your brand prominent by adding your logo and'
        //       + 'selecting a background theme that matches your brand.',
        //   cta: { name: 'cobranding' },
        //   disabled: !this.user.override_cobranding,
        //   coach: true,
        // },
        {
          title: 'Subscription',
          // eslint-disable-next-line global-require
          icon: require('@/assets/settings/subscriptions.png'),
          description: 'Update your subscription model for your GCG services',
          direct: process.env.VUE_APP_ENV === 'prod' ? 'https://gcgroup.chargebeeportal.com/portal/'
            : 'https://gcgroup-test.chargebeeportal.com/portal/',
          cta: { name: 'subscription' },
          disabled: false,
        },
        // {
        //   title: 'Calendar Connections',
        //   // eslint-disable-next-line global-require
        //   icon: require('@/assets/settings/calendar.png'),
        //   description: 'Manage your external calendar connections to sync with GCG services.'
        //       + 'Sync your calendars here to easily manage your coaching availability'
        //       + 'within the GCG Platform and'
        //       + 'other MNC enterprise versions of the GCG Platform',
        //   cta: { name: 'calendars' },
        //   disabled: false,
        //   coach: true,
        // },
      ].filter((el) => {
        if (el.coach) return this.user.is_coach;
        return true;
      });

      return options;
    },

    hasGla() {
      let flag = false;
      if (this.user && this.user.services) {
        flag = this.user.services.some((el) => el.service_id === 'gla360');
      }
      return flag;
    },
  },

  methods: {
    goToPlan() {
      window.open('https://gla-360.com/plans/', '_blank');
    },

    sendToDirect(url) {
      window.open(`${url}`, '_blank');
    },
  },
};
</script>
